// Landing (root domain) vs App (app. subdomain) — same codebase, decided by hostname.
const LANDING_HOSTS = (process.env.REACT_APP_LANDING_HOSTS || "")
  .split(",")
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

export const isLandingHost = () => {
  const host = window.location.hostname.toLowerCase();
  if (LANDING_HOSTS.includes(host)) return true;
  return /^\/landing\/?$/.test(window.location.pathname);
};

// Where the landing sends visitors. On the real landing host we use the configured app URL;
// in preview (/landing path) we stay on the same origin so the flow can be tested end-to-end.
export const appUrl = () => {
  const host = window.location.hostname.toLowerCase();
  const configured = (process.env.REACT_APP_APP_URL || "").replace(/\/$/, "");
  if (configured && LANDING_HOSTS.includes(host)) return configured;
  return window.location.origin;
};

const UTM_FORWARD = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "gclid", "fbclid"];

export const goToApp = ({ prompt, auth } = {}) => {
  const params = new URLSearchParams();
  if (prompt && prompt.trim()) params.set("prompt", prompt.trim());
  if (auth) params.set("auth", auth);
  // keep the campaign visible to GA4 on the app subdomain too
  const cur = new URLSearchParams(window.location.search);
  UTM_FORWARD.forEach((k) => { const v = cur.get(k); if (v) params.set(k, v); });
  const qs = params.toString();
  window.location.href = `${appUrl()}/${qs ? `?${qs}` : ""}`;
};

const ADMIN_HOSTS = (process.env.REACT_APP_ADMIN_HOSTS || "")
  .split(",")
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

export const isAdminHost = () => {
  const host = window.location.hostname.toLowerCase();
  if (ADMIN_HOSTS.includes(host)) return true;
  return /^\/admin(\/|$)/.test(window.location.pathname);
};
